<template>
  <div class="app">
    <StarField @loaded="starfieldLoaded" />
    <div 
      class="background-placeholder" 
      :class="{ 'fade-out': isStarfieldLoaded }"
      :style="gradientStyle"
    ></div>
    <PortfolioSection />
  </div>
</template>

<script>
import StarField from './components/StarField.vue'
import PortfolioSection from './components/Portfolio.vue'
import { ref, computed, onMounted } from 'vue'

export default {
  name: 'App',
  components: {
    StarField,
    PortfolioSection
  },
  setup() {
    const isStarfieldLoaded = ref(false);
    const gradientConfig = ref(null);
    
    const starfieldLoaded = () => {
      isStarfieldLoaded.value = true;
    };
    
    const gradientStyle = computed(() => {
      if (!gradientConfig.value) {
        return { backgroundColor: '#0b0b1a' }; // Default fallback
      }
      
      try {
        const stops = gradientConfig.value.stops;
        const direction = gradientConfig.value.direction === 'vertical' ? 'to bottom' : 'to right';
        
        const cssStops = stops.map(stop => {
          const { r, g, b, a } = stop.color;
          return `rgba(${r * 255}, ${g * 255}, ${b * 255}, ${a}) ${stop.position * 100}%`;
        }).join(', ');
        
        return {
          background: `linear-gradient(${direction}, ${cssStops})`
        };
      } catch (error) {
        console.error('Error parsing gradient config:', error);
        return { backgroundColor: '#0b0b1a' }; // Fallback on error
      }
    });
    
    onMounted(async () => {
      try {
        const response = await fetch('/config/starfield-config.json');
        const config = await response.json();
        gradientConfig.value = config.gradient;
      } catch (error) {
        console.error('Failed to load gradient configuration:', error);
      }
    });
    
    return {
      isStarfieldLoaded,
      starfieldLoaded,
      gradientStyle
    };
  }
}
</script>

<style>
html {
  width: 100vw;
  overflow-x: hidden;
  color: #fff;
  box-sizing: border-box;
  scroll-behavior: smooth;
  background: transparent;
}

body {
  margin: 0;
  background: transparent;
  font-family: 'Roboto', 'Helvetica Neue', sans-serif;
  line-height: 1.6;
}

*, *:before, *:after {
  box-sizing: inherit;
}

.app {
  position: relative;
  min-height: 100vh;
}

.background-placeholder {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1; /* Between starfield (-2) and content */
  transition: opacity 1.5s ease;
}

.fade-out {
  opacity: 0;
}
</style>
